export default class WholeSaleUtil {
  /** @type {Condition[]} */
  __conditions = []
  /** @type {number|null} */
  __quantity = null
  /** @type {number|null} */
  __retail = null
  /** @type {ActiveTierCache|null} */
  __activeTierCache = null
  /**
   * Description
   * @param {Condition[]} conditions
   */
  constructor(conditions) {
    this.setConditions(conditions)
  }

  setConditions(conditions) {
    this.__conditions = conditions
      .filter(c => c && (c.isActive === undefined || c.isActive === 1))
      .sort((a, b) => Number(a.minQuantity) - Number(b.minQuantity))
  }

  /**
   * Description
   * @param {number} quantity
   */
  setQuantity(quantity) {
    this.__quantity = quantity
  }

  /**
   * Description
   * @param {number} retail
   */
  setRetail(retail) {
    this.__retail = retail
  }

  getActiveTier() {
    if (!this.__quantity) return null
    if (this.__activeTierCache?.quantity === this.__quantity) return this.__activeTierCache.condition
    /** @type {Condition|null} */
    let currentCondition = null
    for (const condition of this.__conditions) {
      if (condition.minQuantity > this.__quantity) return currentCondition
      currentCondition = condition
      this.__activeTierCache = {
        quantity: this.__quantity,
        condition,
      }
    }
    return currentCondition
  }

  /**
   * 
   * @returns {{type: 'rate'|'fixed', value: number}|null}
   */
  getDiscount() {
    const tier = this.getActiveTier()
    if (!tier) return null
    if (tier.discountPercentage) return {
      type: 'rate',
      value: tier.discountPercentage / 100,
    }
    if (tier.discountFixed) return {
      type: 'fixed',
      value: tier.discountFixed,
    }
    return null
  }
}

/**
 * @typedef {Object} Condition
 * @property {number} minQuantity
 * @property {number} discountPercentage
 * @property {number} discountFixed
 * @property {boolean} isActive
 * 
 * @typedef {Object} ActiveTierCache
 * @property {number} quantity
 * @property {Condition|null} condition 
 */